//Tabs
export const PAExtensions_Header = "PA EXTENSIONS";
export const RejectedExtensions_Header = "REJECTED EXTENSIONS";
export const Configurations_Header = "CONFIGURATIONS";
export const DefaultGroup = {
    AuthExt_CNS_READ: "CNS_IT_Users"
}

//Error messages
export const UnAuthorized = "401";
export const UnAuthorizedMessage = "You are not authorized to view this page";
export const InvalidMessage = "Invalid input";
export const NotFound = "404";
export const NotFoundMessage = "Page Not Found";
export const GeneralError = "Oops! Something went wrong. Please try again later.";
export const Error = "Oops!"

//Regex
export const regexWithNumbers = /^[a-zA-Z0-9]*$/;
export const regexWithoutNumbers = /^[a-zA-Z]*$/;
export const regexOnlyNumbers = /^[0-9]*$/;
export const regexNumbersSpecialChar = /^[0-9*]*$/;
export const regexNumbersSpecialCharLong = /^[a-zA-Z0-9*+.]*$/;
export const regexNumbersCharSpecialChar = /^[a-zA-Z0-9-]*$/;
export const regexNumberWithStar = /^[0-9*]*$/;

//Length
export const accountInputLen = 10;
export const groupInputLen = 20;
export const memberInputLen = 15;
export const gpiInputLen = 20;